module.exports = __webpack_public_path__ + "static/media/door.a484d122.obj";